import { render, staticRenderFns } from "./TickData.vue?vue&type=template&id=084c6034&"
import script from "./TickData.vue?vue&type=script&lang=js&"
export * from "./TickData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports